<!--<h3>{{ 'dataTransformations.searchTransformations' | translate }}</h3>-->
<div class="row fields-group">
    <div class="col">
        <label for="search-transformation-field" class="d-block list-title">{{ 'dataTransformations.searchCondition' | translate }}</label>
        <select id="search-transformation-field" class="d-flex w-100 form-control" [(ngModel)]="searchTransformation" (change)="searchUpdate()">
            <option value="none" selected></option>
            <option value="useAsFullTextSearch">Contains</option>
            <option value="useAsExactSearch">Exact match</option>
            <option value="useAsStartsWith">Starts with</option>
        </select>
    </div>
</div>
